const ownerData = {
    joint_title: '',
    joint_first_name: '',
    joint_last_name: '',
    joint_middle_name: '',
    joint_birth: '',
    joint_citizenship_status: '',
    joint_ssn: '',
    joint_confirm_ssn: '',
    joint_iden_type: '',
    joint_iden_number: '',
    joint_issue_date: '',
    joint_exp_date: '',
    joint_spouse: 'N',
    joint_same_add: 'Y',
    joint_mobile_phone: '',
    joint_emp_status: '',
    joint_member: 'N',
    joint_indicate1: '',
    joint_indicate2: '',
    joint_occupation: '',
    joint_company_name: '',
    joint_address: '',
    joint_city: '',
    joint_business_country: '',
    joint_business_state: '',
    joint_zip_code: '',
    joint_school_name: '',
    joint_no_address: '',
    joint_no_address2: '',
    joint_no_city: '',
    joint_no_country: '',
    joint_no_zip_code: '',
    country_of_birth: '',
    country_of_residence: '',
    country_of_citizenship: '',
    joint_no_state: ''
}

const SET_OWNER_INFO = 'SET_OWNER_INFO';
const SET_Owner_TYPE = 'SET_Owner_TYPE';
const SET_SPOUSE_TYPE = 'SET_SPOUSE_TYPE';
const SET_SAME_ADD_TYPE = 'SET_SAME_ADD_TYPE';

export const setOwnerData = (ownerData) => ({
    type: SET_OWNER_INFO,
    payload: ownerData,
});

export const setOwnerType = (joint_member) => ({
    type: SET_Owner_TYPE,
    payload: joint_member,
});

export const setSpouseType = (joint_spouse) => ({
    type: SET_SPOUSE_TYPE,
    payload: joint_spouse,
});

export const setSameAddType = (joint_same_add) => ({
    type: SET_SAME_ADD_TYPE,
    payload: joint_same_add,
});

const owner_store = (state = ownerData, action) => {
    switch (action.type) {
        case SET_Owner_TYPE:
            return {
                ...state,
                joint_member: action.payload,
            };
        case SET_SPOUSE_TYPE:
            return {
                ...state,
                joint_spouse: action.payload,
            };
        case SET_SAME_ADD_TYPE:
            return {
                ...state,
                joint_same_add: action.payload,
            };
        case SET_OWNER_INFO:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};

export default owner_store;
